module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/google-8b33d87d55b64da71b11ffc945915592.png";